import { 
    Container, 
    Content,
    Title, 
    TextList 
} from "./styles";
import { Column } from "components/styles";
import actionImage from "img/action_image.svg";

const GuideMessage = ({
    children
}) => {
    return (
        <Container>
            <Content>
                <img src={actionImage} alt="Imagen de decisión"/>
                <Column justifyContent="center" align="center" gap="10px">
                    <Title textAlign="center">Recuerda:</Title>
                    <TextList>{children}</TextList>
                </Column>
            </Content>
        </Container>
    );
}

export default GuideMessage;